import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=4e5f5b6c&scoped=true&"
import script from "./CartItem.vue?vue&type=script&lang=js&"
export * from "./CartItem.vue?vue&type=script&lang=js&"
import style0 from "./CartItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CartItem.vue?vue&type=style&index=1&id=4e5f5b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f5b6c",
  null
  
)

export default component.exports